import React from 'react';
import { Typography } from '@mui/material';
import { SpacedTexts } from './styles';

const ProgressBarDates = ({ startDate, endDate, status, destination }) => {
  let topRightValue = status === 300 ? 'Stopped' : endDate;

  if (topRightValue === undefined) {
    topRightValue = destination === '' ? 'No destination' : '';
  }

  return (
    <SpacedTexts>
      <Typography
        color="textSecondary"
        fontWeight={500}
      >
        {startDate}
      </Typography>
      <Typography
        color="textSecondary"
        fontWeight={500}
      >
        {topRightValue}
      </Typography>
    </SpacedTexts>
  );
};

export default ProgressBarDates;
